export default __webpack_public_path__ + "static/media/qrCode.be8b38ce.svg";